export default {
  removeAllNavigationClassesFromBody () {
    const list = [...document.body.classList]

    list.forEach(el => {
      if (el.includes('active') || el.includes('notes') || el.includes('activity') || el.includes('tracked')) {
        document.body.classList.remove(el)
      }
    })

    // Send "idle" state to Editor

    return null
  },

  setActiveMenu ({ commit, dispatch, state }, what) {
    // Close all (happens when main menu closes)
    if (what === '') {
      dispatch('removeAllNavigationClassesFromBody')
    }

    // first opening
    if (what !== '' && state.activeMenu === '') {
      // Does not work, DOM gets overwritten later... but where and why?
      // const list = document.body.classList
      document.body.classList.add('active-' + what)
    }

    // Close old menu, open new one:
    //    but could also be empty string, so check!!!!
    if (what !== state.activeMenu && what !== '' && state.activeMenu !== '') {
      // Remove old class
      // document.body.classList.remove('active-' + state.activeMenu)
      dispatch('removeAllNavigationClassesFromBody')
      // activate new class
      document.body.classList.add('active-' + what)
    }

    // Toggle same menu:
    //    but could also be empty string!!!!
    if (what === state.activeMenu && what !== '') {
      // document.body.classList.toggle('active-' + what)

      dispatch('removeAllNavigationClassesFromBody')
      // Set "what" to empty
      what = ''
    }

    commit('SET_ACTIVE_MENU', what)
  },

  toggleMainNavStatus ({ commit }, bool = undefined) {
    commit('TOGGLE_MAIN_NAV_STATUS', bool)
  },

  // Track Characteristics
  setTrackStrokeColor ({ commit }, val) {
    commit('SET_TRACK_STROKE_COLOR', val)
  },

  setTrackStrokeWidth ({ commit }, array) {
    commit('SET_TRACK_STROKE_WIDTH', array)
  }
}
